import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonAlert, IonIcon, IonItem, IonLabel } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccountService } from '../account.service';

@Component({
  selector: 'lib-lang-select',
  templateUrl: './lang-select.component.html',
  styleUrls: ['./lang-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonAlert, IonLabel, IonIcon, IonItem, TranslateModule],
})
export class LangSelectComponent {
  private readonly translate = inject(TranslateService);
  private readonly accountService = inject(AccountService);

  private _defaultLang = computed(() => this.accountService.account().lang || 'en');

  protected alertButtons = computed(() => {
    if (this._defaultLang()) {
      return [
        {
          text: this.translate.instant('general.select'),
          role: 'confirm',
        },
      ];
    } else {
      return [];
    }
  });

  protected alertInputs = computed(() => {
    if (this._defaultLang()) {
      return [
        {
          label: this.translate.instant('general.lang.es'),
          type: 'radio',
          value: 'es',
          checked: this._defaultLang() === 'es',
        },
        {
          label: this.translate.instant('general.lang.en'),
          type: 'radio',
          value: 'en',
          checked: this._defaultLang() === 'en',
        },
      ];
    } else {
      return [];
    }
  });

  protected async setLang(event: any): Promise<void> {
    if (event.detail.role === 'confirm') {
      const newLang = event.detail.data.values;
      this._defaultLang = newLang;
      try {
        await this.accountService.changeLang(newLang);
      } catch (error) {
        console.error('Error al cambiar el idioma:', error);
      }
    }
  }
}
